import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import { LocaleContext } from '../../locale-context';
import TranslateStatic from '../../locales/TranslateStatic';
import axios from 'axios';

const API_KEY = "AIzaSyB-bOMjkCW9qV8Pmy2CwMoPtoZUeQP0hdw";
const PLAYLIST_TR = "PLLTGKC6AlQ_LUQh0_EFUhnYn-aFfKlQaU";
const PLAYLIST_EN = "PLLTGKC6AlQ_J_9cuv7LtOEpIV70Bk0Mso";

export function Youtube() {
  const [activeVideo, setActiveVideo] = useState(null);
  const [videos, setVideos] = useState([]);
  const localeValue = useContext(LocaleContext);

  useEffect(() => {
    const playlistId = localeValue === "tr" ? PLAYLIST_TR : PLAYLIST_EN;
    
    axios.get(`https://www.googleapis.com/youtube/v3/playlistItems`, {
      params: {
        part: 'snippet',
        maxResults: 50,
        playlistId: playlistId,
        key: API_KEY
      }
    })
    .then(response => {
      if (response.data && response.data.items) {
        const fetchedVideos = response.data.items.map(item => ({
          id: item.snippet.resourceId.videoId,
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails?.maxres?.url || item.snippet.thumbnails?.high?.url || `https://img.youtube.com/vi/${item.snippet.resourceId.videoId}/hqdefault.jpg`
        }));
        setVideos(fetchedVideos);
      }
    })
    .catch(error => {
      console.error("Error fetching YouTube playlist", error);
    });
  }, [localeValue]);

  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="Videolar" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="Videolar" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="gallery-container">
          <div className="intro-text">
            <p><TranslateStatic string="IlacAnlatimiMetin" /></p>
          </div>
          
          <div className="mapContainer">
            {videos.map((vid, index) => (
              <div key={index} className="video-card" onClick={() => setActiveVideo(vid.id)}>
                <div className="iframe-wrapper">
                  <img src={vid.thumbnail} alt={vid.title} />
                  <div className="gradient-overlay"></div>
                  <div className="play-button-overlay">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                  <div className="video-title">
                    <h3>{vid.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </S.ContentWrapper>

      {activeVideo && (
        <S.ModalOverlay onClick={() => setActiveVideo(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setActiveVideo(null)}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
            <div className="modal-video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </S.ModalOverlay>
      )}
    </S.PageWrapper>
  );
}
